<template>
  <div>
    <label v-text="label" />
    <editor
      :id="editorId"
      v-model="content"
      :api-key="'l2kditken5n9bjvnapr1o00vdwe2lbn6pugjmi0hradmz5z9'"
      :init="{
        height: 500,
        menubar: false,
        plugins: [
          'advlist autolink lists link image charmap print preview anchor',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime image imagetools table paste code help wordcount fontsizes'
        ],
        toolbar:
          'undo redo | formatselect | fontsizeselect | bold italic forecolor backcolor | table | \
          alignleft aligncenter alignright alignjustify | \
          bullist numlist outdent indent | removeformat | image | imagetools link',
        contextmenu: 'undo redo link image table copy paste',
        automatic_uploads: true,
        image_title: true,
        relative_urls : false,
        remove_script_host : false,
        convert_urls : true,
        images_upload_handler: handleImageUpload,
        file_picker_types: 'image',
        fontsize_formats: '8px 10px 12px 14px 16px 18px 20px 24px 36px',
        extended_valid_elements: 'a[href|target|rel]',
        rel_list: [
          {title: 'None', value: ''},
          {title: 'No follow', value: 'nofollow'},
          {title: 'No index', value: 'noindex'},
          {title: 'No follow, No index', value: 'nofollow noindex'},
        ],
      }"
    />
    <p
      v-if="error"
      class="text-danger"
      v-html="error"
    />
  </div>
</template>

<script>
  import Editor from '@tinymce/tinymce-vue'
  import getApiClient from '@/plugins/api-client'

  export default {
    name: 'TextEditor',
    components: {
      Editor,
    },
    props: {
      value: {
        type: String,
        required: true,
      },
      label: {
        type: String,
        default: 'Conteúdo',
      },
      error: {
        type: String,
        required: false,
      },
    },
    emits: ['input'],
    data: function () {
      return {
        modelValue: '',
        content: this.value,
        editorId: 'editor-' + Math.random().toString(36).substring(7),
      }
    },
    watch: {
      content: function (value) {
        this.$emit('input', value)
      },
      modelValue: function (value) {
        this.content = value
      },
    },
    methods: {
      handleImageUpload: async function (blobInfo, progress, failure) {
        const formData = new FormData()
        const api = getApiClient(this.$store)
        formData.append('file', blobInfo.blob(), blobInfo.filename())

        try {
          const response = await api.post(
            '/dashboard/editor/image/upload',
            formData,
            {
              headers: { 'Content-Type': 'multipart/form-data' },
            },
          )
          const json = response.data
          progress(json.location)
          return json.location
        } catch (error) {
          if (failure && typeof failure === 'function') {
            failure('aaa')
          }
        }
      },
    },
  }
</script>
